module.exports = __webpack_public_path__ + "static/media/panis_18.2c3289bc.jpg";